import interpolateComponents from 'interpolate-components';
import { useContext } from 'react';
import {
  SECURITY_REPORT_DISCLOSURE_KEYS,
  SECURITY_REPORT_TITLE,
} from '../../constants/localizations/security';
import { LINE_BREAK_INTERPOLATE } from '../../constants/localizations/shared';
import { SECURITY_REPORT_PAGE_URL } from '../../constants/security';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import SeoHelmet from '../SeoHelmet';
import { BugcrowdSubmissionForm } from './BugcrowdSubmissionForm';
import css from './security-report.module.scss';

export function SecurityReportRoute() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const title = getLocalizedText(SECURITY_REPORT_TITLE);
  const documentTitle = title.replace(LINE_BREAK_INTERPOLATE, ' ');
  const formattedTitle = interpolateComponents({
    mixedString: title,
    components: { linebreak: <br /> },
  });
  const renderDisclosureItems = (keys: readonly string[]) =>
    keys.map((key) => (
      <li key={key}>
        {interpolateComponents({
          mixedString: getLocalizedText(key),
          components: { strong: <strong /> },
        })}
      </li>
    ));

  return (
    <main className={css.page} data-testid="securityReportPage">
      <SeoHelmet
        title={documentTitle}
        description=""
        name="TuneIn"
        image=""
        url={SECURITY_REPORT_PAGE_URL}
        links={[]}
        meta={[]}
        additionalJsonLd={{}}
        includeJsonLd={false}
      />
      <h1 className={css.title}>{formattedTitle}</h1>
      <hr className={css.divider} />
      <section className={css.disclosure} aria-labelledby="securityDisclosurePolicyTitle">
        <h2 id="securityDisclosurePolicyTitle" className={css.disclosureTitle}>
          {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.title)}
        </h2>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.philosophy.title)}
          </h3>
          <p>{getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.philosophy.body)}</p>
        </section>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.researchers.title)}
          </h3>
          <p>{getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.researchers.body)}</p>
        </section>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.scope.title)}
          </h3>
          <p>{getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.scope.body)}</p>
        </section>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.commitment.title)}
          </h3>
          <ul className={css.disclosureList}>
            {renderDisclosureItems(SECURITY_REPORT_DISCLOSURE_KEYS.commitment.items)}
          </ul>
        </section>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.researcherRequests.title)}
          </h3>
          <ul className={css.disclosureList}>
            {renderDisclosureItems(SECURITY_REPORT_DISCLOSURE_KEYS.researcherRequests.items)}
          </ul>
        </section>

        <section className={css.disclosureSection}>
          <h3 className={css.disclosureSectionTitle}>
            {getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.reporting.title)}
          </h3>
          <p>{getLocalizedText(SECURITY_REPORT_DISCLOSURE_KEYS.reporting.body)}</p>
        </section>
      </section>
      <hr className={css.divider} />
      <BugcrowdSubmissionForm />
    </main>
  );
}
